import { MouseEventHandler } from "react";

import {
  faEdit,
  faPlugCircleBolt,
  faTrashCan,
} from "@fortawesome/pro-regular-svg-icons";

import type { CredentialItem } from "src/clients/agent-management";
import { RawCell } from "src/dataTable/RawCell";
import { IconButton } from "src/design-system/Icon";
import { Tooltip } from "src/design-system/Tooltip";

type Props = {
  credential: CredentialItem;
  onEditClick: MouseEventHandler;
  onDeleteClick: MouseEventHandler;
  onTestClick: MouseEventHandler;
};

export const CredentialActions: React.FC<Props> = ({
  credential,
  onEditClick,
  onDeleteClick,
  onTestClick,
}) => {
  const actions = (
    <div className="flex items-center justify-end gap-x-2">
      <Tooltip placement="top" title="Edit credentials" asChild>
        <IconButton
          dataLoc={`edit-credential-${credential.id}`}
          icon={faEdit}
          size="xs"
          onClick={onEditClick}
        />
      </Tooltip>
      <Tooltip placement="top" title="Test credentials" asChild>
        <IconButton
          dataLoc={`test-credential-${credential.id}`}
          icon={faPlugCircleBolt}
          size="xs"
          onClick={onTestClick}
        />
      </Tooltip>
      <Tooltip placement="top" title="Delete credentials" asChild>
        <IconButton
          dataLoc={`delete-credential-${credential.id}`}
          icon={faTrashCan}
          size="xs"
          onClick={onDeleteClick}
        />
      </Tooltip>
    </div>
  );

  return (
    <RawCell
      cell={actions}
      classNameOverrides="min-h-[48px] invisible flex items-right justify-end group-hover:visible max-w-0"
    />
  );
};
